import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ZoomOutRoundedIcon from '@mui/icons-material/ZoomOutRounded';
import CommonFooter from '../common_components/CommonFooter';
const PINK = '#FF008E';
const BG = '#F8F9FC';
const SURFACE = '#FFFFFF';
const BORDER = '#E9EAEB';
const T1 = '#181D27';
const T2 = '#717680';
export default function PageNotFound({ isDashboard = false }) {
    const [mounted, setMounted] = useState(false);
    const [checkAnim, setCheckAnim] = useState(false);
    useEffect(() => {
        const t1 = setTimeout(() => setMounted(true), 80);
        const t2 = setTimeout(() => setCheckAnim(true), 500);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, []);
    return (_jsxs(Box, { sx: isDashboard ? {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
        } : {
            minHeight: '100vh',
            backgroundColor: BG,
            fontFamily: 'Inter, system-ui, sans-serif',
            display: 'flex',
            flexDirection: 'column',
            backgroundImage: `radial-gradient(circle, ${BORDER} 1px, transparent 1px)`,
            backgroundSize: '24px 24px',
        }, children: [!isDashboard && (_jsx(Box, { sx: {
                    height: 60,
                    backgroundColor: SURFACE,
                    borderBottom: `1px solid ${BORDER}`,
                    display: 'flex',
                    alignItems: 'center',
                    px: { xs: 3, sm: '40px' },
                    flexShrink: 0,
                    boxShadow: '0px 1px 2px rgba(10,13,18,0.04)',
                }, children: _jsx(Box, { component: "img", src: "/assets/loginImage/logo-final.svg", alt: "Group8A", sx: { height: 28 } }) })), _jsx(Box, { sx: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 2,
                    py: 5,
                }, children: _jsx(Box, { sx: {
                        width: '100%',
                        maxWidth: 500,
                        opacity: mounted ? 1 : 0,
                        transform: mounted ? 'translateY(0)' : 'translateY(24px)',
                        transition: 'opacity 0.5s ease, transform 0.5s ease',
                    }, children: _jsxs(Box, { sx: { textAlign: 'center', mb: 3.5 }, children: [_jsxs(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mb: 3
                                }, children: [_jsx(Box, { component: "span", sx: { fontSize: '110px !important', fontWeight: 900, color: '#1A1A1A', lineHeight: 1 }, children: "4" }), _jsxs(Box, { sx: { display: 'inline-flex', position: 'relative', mx: 2 }, children: [_jsx(Box, { sx: {
                                                    position: 'absolute',
                                                    inset: -8,
                                                    borderRadius: '50%',
                                                    border: `1.5px solid ${PINK}`,
                                                    opacity: checkAnim ? 0 : 0.5,
                                                    transform: checkAnim ? 'scale(1.5)' : 'scale(1)',
                                                    transition: 'opacity 0.8s 0.6s ease, transform 0.8s 0.6s ease',
                                                    pointerEvents: 'none',
                                                } }), _jsx(Box, { sx: {
                                                    width: 90,
                                                    height: 90,
                                                    borderRadius: '50%',
                                                    backgroundColor: checkAnim ? PINK : SURFACE,
                                                    border: `2px solid ${checkAnim ? PINK : BORDER}`,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'background-color 0.4s ease, border-color 0.4s ease',
                                                    boxShadow: checkAnim
                                                        ? `0 0 0 6px #ffe6f3, 0 8px 24px ${PINK}33`
                                                        : 'none',
                                                }, children: _jsx(ZoomOutRoundedIcon, { sx: {
                                                        color: checkAnim ? 'white' : PINK,
                                                        fontSize: '48px !important',
                                                        transition: 'color 0.4s ease'
                                                    } }) })] }), _jsx(Box, { component: "span", sx: { fontSize: '110px !important', fontWeight: 900, color: '#1A1A1A', lineHeight: 1 }, children: "4" })] }), _jsx(Typography, { sx: {
                                    fontWeight: 700,
                                    color: T1,
                                    lineHeight: 1.2,
                                    letterSpacing: '-0.4px',
                                    mb: 1.5,
                                    fontSize: '1.8rem'
                                }, className: "head-Font-Sizes", children: "Page not found." }), _jsx(Typography, { sx: { fontSize: '1rem', color: T2, lineHeight: 1.6, px: 2 }, children: "The page you\u2019re looking for doesn\u2019t exist or may have been moved. Check the URL, or head back to your dashboard." })] }) }) }), !isDashboard && _jsx(CommonFooter, {})] }));
}
